import { Component, OnInit } from '@angular/core';
import { AccountingReportsService } from '../accounting-reports.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Utils } from '../../../../shared/utils';
import { SumasySaldosGroupAccountsModel, SumasySaldosGroupModel, SumasySaldosView } from '../../models/sumasysaldosGroup.model';
import { UserCompanyModel } from '../../../user/usercompany/usercompany.model';
import { UserCompanyService } from '../../../user/usercompany/usercompany.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CoreComponent } from '../../../../core/header/core.component';
import * as FileSaver from 'file-saver';
import { consts } from '../../../../consts';
import { AccountingAccountsDialogLedgerComponent } from '../../accounting-accounts/accounting-accounts-dialog-ledger.component';
import { MatDialog } from '@angular/material/dialog';
import { Option } from '../../../../shared/models/option.model';

@Component({
    selector: 'convfact-accounting-sumasysaldos',
    templateUrl: './accounting-sumasysaldos.component.html',
    styleUrls: ['./accounting-sumasysaldos.component.css'],
    standalone: false
})
export class AccountingSumasySaldosComponent implements OnInit {
  group: SumasySaldosGroupAccountsModel[] = [];
  groups: string[] = [];

  fromFilterBalance: number;
  toFilterBalance: number;
  globalFilterBalance: boolean = false;
  public levelAccounts: string = '1';

  public levelAccountsOptions: Option[] = [
    { label: 'Cuentas auxiliares', value: '0' },
    { label: 'Nivel 1', value: '1' },
    { label: 'Nivel 2', value: '2' },
    { label: 'Nivel 3', value: '3' },
  ];

  totalDebe: number = 0;
  totalHaber: number = 0;
  totalDeudor: number = 0;
  totalAcreedor: number = 0;
  saldo: number = 0;
  saldoDeudor: number = 0;
  saldoAcreedor: number = 0;

  dataSource: SumasySaldosView[];
  userCompany: UserCompanyModel;
  ready = false;

  constructor(
    private accountingReportsService: AccountingReportsService,
    private userCompanyService: UserCompanyService,
    public snackBar: MatSnackBar,
    public core: CoreComponent,
    public dialog: MatDialog
  ) {}

  public createExcel(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    if (this.ready === false) {
      this.displayInfo("Para descargar el Excel, primero debes consultar la información. Haz clic en el botón 'Consultar' para continuar");
      return;
    }

    const data = new SumasySaldosGroupModel();
    data.from = this.fromFilterBalance;
    data.to = this.toFilterBalance;
    data.global = this.globalFilterBalance;
    data.levelAccounts = this.levelAccounts;
    data.groups = this.group;

    this.accountingReportsService.getExcelSumasySaldos(this.dataSource, data)
      .then(response => {
        FileSaver.saveAs(response, Utils.GetExcelName('Balance Sumas y Saldos'));
      })
      .catch(() => {
        this.displayInfo('Ha ocurrido un error inesperado al exportar el documento excel');
      });
  }

  public createPDF(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    if (this.ready === false) {
      this.displayInfo("Para descargar el PDF, primero debes consultar la información. Haz clic en el botón 'Consultar' para continuar");
      return;
    }

    const data = new SumasySaldosGroupModel();
    data.from = this.fromFilterBalance;
    data.to = this.toFilterBalance;
    data.global = this.globalFilterBalance;
    data.levelAccounts = this.levelAccounts;
    data.groups = this.group;

    this.accountingReportsService.getPdfSumasySaldos(this.dataSource, data)
      .then(response => {
        FileSaver.saveAs(response, Utils.GetPdfName('Balance_Sumas_Saldos'));
      })
      .catch(() => {
        this.displayInfo('Ha ocurrido un error inesperado al generar el PDF');
      });
  }

  public ngOnInit(): void {
    this.initGroups();

    const activities = this.core.activity;
    if (activities.length == 1) {
      this.changeGlobalFilterBalance();
    }

    this.userCompanyService.loadData().then(response => {
      this.userCompany = response;
    });
  }

  public initGroups(): void {
    const actualDate: Date = new Date();
    let actualMonth: number = actualDate.getMonth();
    actualMonth++;
    this.changeFromFilterBalance(0);
    this.changeToFilterBalance(actualMonth);

    for (let i = 0; i < 10; i++) {
      const temp = new SumasySaldosGroupAccountsModel();
      temp.checked = false;
      temp.group = i.toString();
      this.group.push(temp);
    }
  }

  changeFromFilterBalance(value: number): void {
    this.fromFilterBalance = value;
  }

  changeToFilterBalance(value: number): void {
    this.toFilterBalance = value;
  }

  public changeGlobalFilterBalance(): void {
    this.globalFilterBalance = !this.globalFilterBalance;
  }

  public toggle(group: number, event: MatCheckboxChange): void {
    if (group === 10) {
      for (let i = 0; i < this.group.length; i++) {
        this.group[i].checked = event.checked;
      }

      return;
    }
  }

  public init(): void {
    this.dataSource.forEach(item => {
      if (item.haber < 0) item.haber = item.haber * -1;
      if (item.debe < 0) item.debe = item.debe * -1;
      if (item.saldoDeudor < 0) item.saldoDeudor = item.saldoDeudor * -1;
      if (item.saldoAcreedor < 0) item.saldoAcreedor = item.saldoAcreedor * -1;

      if (item.debe == 0) item.saldoDeudor = 0;
      if (item.haber == 0) item.saldoAcreedor = 0;
    });
  }

  public getData(): void {
    this.totalDebe = 0;
    this.totalHaber = 0;
    this.totalDeudor = 0;
    this.totalAcreedor = 0;
    this.saldo = 0;
    this.saldoDeudor = 0;
    this.saldoAcreedor = 0;

    this.groups = [];
    this.group.forEach(element => {
      if (element.checked) {
        this.groups.push(element.group);
      }
    });

    this.totalDebe = 0;
    this.totalHaber = 0;
    this.totalDeudor = 0;
    this.totalAcreedor = 0;
    this.saldo = 0;

    const data = new SumasySaldosGroupModel();
    data.from = this.fromFilterBalance;
    data.to = this.toFilterBalance;
    data.global = this.globalFilterBalance;
    data.levelAccounts = this.levelAccounts;
    data.groups = this.group;

    this.accountingReportsService.getSumasySaldos(data).then(response => {
      this.dataSource = response;

      this.dataSource.forEach(element => {
        if ((element.debe - element.haber) > 0 || (element.debe < 0)) {
          element.saldoDeudor = element.debe - element.haber;
          element.saldoAcreedor = 0;
        } else if ((element.debe - element.haber) < 0) {
          element.saldoDeudor = 0;
          element.saldoAcreedor = element.debe - element.haber;
        }

        this.totalDebe += element.debe;
        this.totalHaber += element.haber;
        this.totalDeudor += element.saldoDeudor;
        this.totalAcreedor += element.saldoAcreedor;

        element.haber = Utils.GetValueWithDecimals(element.haber);
        element.debe = Utils.GetValueWithDecimals(element.debe);
        element.saldoDeudor = Utils.GetValueWithDecimals(element.saldoDeudor);
        element.saldoAcreedor = Utils.GetValueWithDecimals(element.saldoAcreedor);
      });

      if (this.totalAcreedor > 0) {
        this.saldo = this.totalDeudor - this.totalAcreedor;
      } else {
        this.saldo = this.totalDeudor + this.totalAcreedor;
      }

      if (this.saldo < 0) {
        this.saldoAcreedor = this.saldo;
      }
      if (this.saldo > 0) {
        this.saldoDeudor = this.saldo;
      }

      this.saldo = Utils.GetValueWithDecimals(this.saldo);
      this.totalDebe = Utils.GetValueWithDecimals(this.totalDebe);
      this.totalHaber = Utils.GetValueWithDecimals(this.totalHaber);
      this.saldoAcreedor = Utils.GetValueWithDecimals(this.saldoAcreedor);
      this.saldoDeudor = Utils.GetValueWithDecimals(this.saldoDeudor);
      this.totalDeudor = Utils.GetValueWithDecimals(this.totalDeudor);
      this.totalAcreedor = Utils.GetValueWithDecimals(this.totalAcreedor);

      this.ready = true;
    });
  }

  private displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }

  public ledger(id: number, name: string, number: string): void {
    this.dialog.open(AccountingAccountsDialogLedgerComponent, {
      width: '700px',
      maxWidth: '96vw',
      
      maxHeight: '90vh',
      autoFocus: false,
      data: {
        id: id,
        name: name,
        number: number
      }
    });
  }
  public trackByIndex(i: number) { return i; }

}